export default __webpack_public_path__ + "static/media/store-2.b606f2d4.png";